module.exports = __webpack_public_path__ + "assets/img/bg.a352678c.png";